// dialog.component.ts
import { Component, ChangeDetectionStrategy } from '@angular/core';


import { ButtonModule, ModalModule } from '@coreui/angular';
import { DialogData ,  DialogService } from '../../services/dialog.service';

@Component({
    standalone: true,   
  imports: [
    ModalModule,
    ButtonModule
],
  selector: 'app-dialog',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent {
  data: DialogData | null = null;
  visible = false;

  constructor(private dialogService: DialogService) {
        this.dialogService.dialog$.subscribe(d => {
      if (d) {
        this.data = d;
        this.visible = true;
      } 
    });
  }

 onModalVisibleChange(val: boolean) {
    if (!val) {
      this.close();
    }
  }



  close() {
    this.visible = false;
    this.data = null;    
    this.dialogService.closeDialog();
  }
}
